export type QuestionType = '1' | '2' | '21' | '3'| '4';

interface BaseQuestion {
  queryId: string;
}

interface StandardQuestion extends BaseQuestion {
  type: '1' | '2';
  title: string;
}

export interface CustomQuestion extends BaseQuestion {
  type: '4';
  title: string;
  responseType: string;
}

export interface RedirectQuestion extends BaseQuestion {
  type: '21';
  title: string;
  url: string;  // Required for URL type
}

export type Question = StandardQuestion | RedirectQuestion | CustomQuestion;

export const QUESTION_TYPE_LABELS: Record<QuestionType, string> = {
  '1': 'Scelta multipla',
  '2': 'Risposta libera',
  '21': 'Redirect link',
  '3': 'Vero / Falso',  // ← nuovo
  '4': 'Custom'  // ← nuovo
};

